import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
    name: "QuizQuestion",
    components:{Loading},
    data() {
        return {
            isLoading: true,
            fullPage: true,
            loader: "bars",
            quizList:[],
            quizListSingle:{},
            quiz_keyList:[],
            quiz_key: '',
            questionList:[],
            singleQuestionList:{},
            question:"",
            option_1:"",
            option_2:"",
            answer:"",
            category:"",
            add_quiz_key:"",
            quiz_name:"",
        }
    },
    async created() {
        await this.getAllQuiz();
        this.quiz_key = this.quiz_keyList[0]
        await this.getAllQuizQuestion();
    },
    methods: {
        async getAllQuiz() {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const res = await axios.get(
                    this.$baseUrl +
                    this.$api +
                    this.$version3 +
                    "/quiz/admin-all-quiz",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                //console.log(res)
                if (res.status === 200) {
                    this.quizList = res.data.data
                    this.quiz_keyList = res.data.data.map((el) => {
                        return  el.quiz_key
                    });
                    this.isLoading = false;
                } else {
                    this.$vToastify.error("Could not fetch data!");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
        async getAllQuizQuestion() {
            this.quizList.map((el) => {
                if (el.quiz_key === this.quiz_key){
                    this.quizListSingle = el
                }
            });
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const res = await axios.get(
                    this.$baseUrl +
                    this.$api +
                    this.$version3 +
                    "/quiz/admin-quiz-question-list?quiz_key=" + this.quiz_key,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 200) {
                    this.questionList = res.data.data
                    this.isLoading = false;
                } else {
                    this.$vToastify.error("Could not fetch data!");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
        async getSingle(id) {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const res = await axios.get(
                    this.$baseUrl +
                    this.$api +
                    this.$version3 +
                    "/quiz/admin-get-question-single?id="+ id,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 200) {
                    //console.log(res.data.data)
                    this.singleQuestionList = res.data.data[0]
                    this.isLoading = false;
                } else {
                    this.$vToastify.error("Could not fetch data!");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
            }
        },
        async addQuestion(e) {
            if(this.add_quiz_key === "" || this.add_quiz_key === null){
                this.$vToastify.error("quiz key field is required")
                return
            }
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const data = {
                    question : this.question,
                    option_1 :this.option_1,
                    option_2 :this.option_2,
                    answer :this.answer,
                    category :this.category,
                    quiz_key :this.add_quiz_key,
                    quiz_name :this.quiz_name
                }
                const res = await axios.post(
                    this.$baseUrl + this.$api + this.$version3 + "/quiz/admin-add-question",
                    data,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 201 || res.status === 200) {
                    this.isLoading = false;
                    e.target.reset();
                    document.getElementById('add_btn_close').click();
                    this.$swal.fire({
                        icon: "success",
                        title: "create Question successfully",
                    })
                    this.question = "";
                    this.option_1 = "";
                    this.option_2 = "";
                    this.answer = "";
                    this.category = "";
                    this.add_quiz_key = "";
                    this.quiz_name = "";

                    await this.getAllQuizQuestion()

                } else {
                    this.isLoading = false;
                    this.$vToastify.error("Could not create Cast and crew");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "An error occurred!"
                });
            }
        },
        async update() {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const data = {
                    id : this.singleQuestionList.id,
                    question : this.singleQuestionList.question,
                    option_1 :this.singleQuestionList.option_1,
                    option_2 :this.singleQuestionList.option_2,
                    answer :this.singleQuestionList.answer,
                    category :this.singleQuestionList.category,
                    quiz_key :this.singleQuestionList.quiz_key,
                    quiz_name :this.singleQuestionList.quiz_name
                }
                const res = await axios.post(
                    this.$baseUrl + this.$api + this.$version3 + "/quiz/admin-update-question",
                    data,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 201 || res.status === 200) {
                    this.isLoading = false;
                    document.getElementById('edit_btn_close').click();
                    this.$swal.fire({
                        icon: "success",
                        title: "Update Question successfully",
                    })
                    await this.getAllQuizQuestion()

                } else {
                    this.isLoading = false;
                    this.$vToastify.error("Could not create Cast and crew");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "An error occurred!"
                });
            }
        }
    }
}
